import type { IUser } from '~/models/User';
import type { TRootState } from '~/store/types';

/**
 * The full record redux already holds for `officeId`: the selected office or the
 * signed-in one. Any other location is only a slim `childOffices` row, if that.
 */
export const selectKnownOffice =
  (officeId: string) =>
  (state: TRootState): IUser | undefined => {
    const { user, selectedChildOffice } = state.user;
    if (selectedChildOffice?.id === officeId) return selectedChildOffice as IUser;
    if (user?.id === officeId) return user;
    return undefined;
  };
